import PropTypes from "prop-types"
import { usePathwrightContext } from "../pathwright/PathwrightContext"
import LicenseResourceFlow from "../resource/license/LicenseResourceFlow"
import SchoolQuery from "../school/graphql/SchoolQuery"

function BelltowerLicenseCard(props) {
  const { school } = usePathwrightContext()
  return (
    <SchoolQuery id={props.schoolId}>
      {({ school: licensorSchool }) => (
        <LicenseResourceFlow
          card={props.card}
          id={props.id}
          schoolId={props.schoolId}
          licenseeSchool={school}
          licensorSchool={licensorSchool}
          onLicenseSuccess={props.onLicenseSuccess}
        />
      )}
    </SchoolQuery>
  )
}

BelltowerLicenseCard.displayName = "BelltowerLicenseCard"

BelltowerLicenseCard.propTypes = {
  id: PropTypes.number.isRequired,
  schoolId: PropTypes.number,
  card: PropTypes.object.isRequired,
  onLicenseSuccess: PropTypes.func.isRequired
}

export default BelltowerLicenseCard
